import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface LatestTransactionSummary {
	id: number;
	status: string;
	type: string;
	transactionHash?: string;
}

export interface TransactionDetails {
	id: number;
	merchantId: number;
	merchantName: string;
	userEmail: string;
	userName: string;
	status: string;
	type: string;
	entityType: string;
	blockchain: string;
	currency: string;
	amount: string;
	factAmount: string;
	networkFee: string;
	networkFeeCurrency?: string;
	serviceFee: string;
	usdAmount: string;
	amountRaw?: string;
	amountDecimals?: number;
	factAmountRaw?: string;
	factAmountDecimals?: number;
	networkFeeRaw?: string;
	networkFeeDecimals?: number;
	serviceFeeRaw?: string;
	serviceFeeDecimals?: number;
	transactionHash?: string;
	explorerLink?: string;
	senderAddress?: string;
	recipientAddress: string;
	createdAt: string;
	updatedAt: string;
	isTest: boolean;
	entityId?: number;
	paymentId?: number;
	paymentPublicId?: string;
	paymentMerchantOrderId?: string;
	paymentStatus?: string;
	paymentType?: string;
	paymentCurrency?: string;
	customerEmail?: string;
	orderId?: number;
	orderUuid?: string;
	orderMerchantOrderId?: string;
	orderStatus?: string;
	orderCryptoCurrency?: string;
	orderFiatCurrency?: string;
}

export interface PaginatedTransactionsResponse {
	transactions: TransactionDetails[];
	totalCount: number;
	limit: number;
	offset: number;
}

export interface ListTransactionsParams {
	limit?: number;
	offset?: number;
	search?: string;
	status?: string;
	type?: string;
	currency?: string;
	blockchain?: string;
}

export interface CancelWithdrawalParams {
	transactionId: number;
	reason: string;
	totpCode: string;
}

const transactionProvider = {
	async getTransaction(id: number): Promise<TransactionDetails> {
		const response = await apiRequest.get(withApiPath(`/transactions/${id}`));
		return response.data;
	},

	async listTransactions(
		params: ListTransactionsParams = {},
	): Promise<PaginatedTransactionsResponse> {
		const response = await apiRequest.get(withApiPath("/transactions"), {
			params: {
				limit: params.limit ?? 50,
				offset: params.offset ?? 0,
				search: params.search ?? "",
				status: params.status ?? "",
				type: params.type ?? "",
				currency: params.currency ?? "",
				blockchain: params.blockchain ?? "",
			},
		});
		return response.data;
	},

	async cancelWithdrawal(params: CancelWithdrawalParams): Promise<void> {
		await apiRequest.post(
			withApiPath(`/transactions/${params.transactionId}/cancel`),
			{
				reason: params.reason,
			},
			{
				headers: {
					"X-2FA-Code": params.totpCode,
				},
			},
		);
	},
};

export default transactionProvider;
